import React from 'react';
import PropTypes from 'prop-types';

import Expand from '../icon/expand'

import './browseFolders'
import '../icon/icon.styl'

class BrowseFolders extends React.Component {

    constructor(props){
        super(props);
        this.requestFiles = this.requestFiles.bind(this);
    }

    requestFolders(branch, e) {
        e.preventDefault();
        this.props.requestFolders(branch);
    }

    requestFiles(branch, e) {
        e.preventDefault();
        this.props.requestFiles(branch)({});
    }

    render() {
        let { requestFiles, requestFolders, parent } = this.props;

        return (<div className="browseFolders">
            {parent.expanded && (<ul>{
                parent.subBranches.map((subBranch) => <li key={subBranch.id}>
                    <div className="browseFolders-branch" >
                        <div>
                            {!subBranch.isLeaf && (<button className="library-expand" onClick={(e) => this.requestFolders(subBranch, e)}>
                                <Expand loading={subBranch.subBranchesFetching} expanded={subBranch.expanded} />
                            </button>)}

                            <span data-id={subBranch.id} onClick={e => this.requestFiles(subBranch, e)}>
                                ({subBranch.id}) {subBranch.name}
                            </span>
                        </div>
                    </div>
                    <div className="browseFolders-subBranch" >
                        {subBranch.expanded && subBranch.subBranchesCount>0 && (<BrowseFolders parent={subBranch} requestFolders={requestFolders} requestFiles={requestFiles} />)}
                    </div>
                </li>)}</ul>)}
        </div>);
    }
}

BrowseFolders.propTypes = {
    parent: PropTypes.object.isRequired,
    requestFiles: PropTypes.func.isRequired,
    requestFolders: PropTypes.func.isRequired
}

export default BrowseFolders
